export const ApiQueryKey = {
	products: 'products',
	productType: 'product-types',
	admins: 'admins',

	attributeGroups: 'attribute-groups',
	attributes: 'attributes',
	attributeValues: 'attribute-values',

	colors: 'colors',
	assets: 'assets',
	roles: 'roles',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
